import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check } from 'lucide-react';
const items = [{
  title: 'El diagnóstico de habilidades',
  desc: 'Descubre en 10 minutos qué puedes ofrecer hoy mismo.'
}, {
  title: 'El mapa de oportunidades',
  desc: 'Las 7 formas más rápidas de generar dinero extra esta semana.'
}, {
  title: 'Los scripts listos',
  desc: 'Mensajes exactos para contactar tus primeros clientes sin sentirte incómodo.'
}, {
  title: 'El plan hora a hora',
  desc: 'Qué hacer exactamente en las primeras 48 horas para ver resultados.'
}, {
  title: 'El sistema de seguimiento',
  desc: 'Cómo convertir este ingreso puntual en algo recurrente.'
}];
export const WhatYouGet = () => {
  return <section className="py-20 md:py-24 bg-dark" data-id="element-213">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-214">
        <FadeIn data-id="element-215">
          <div className="text-center mb-14" data-id="element-216">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-217">
              Contenido
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-218">
              ¿Qué encuentras dentro del plan?
            </h2>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-219">
          {items.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-220">
              <div className="bg-[#111111] border border-white/10 rounded-xl p-6 md:p-7 flex items-start gap-5 hover:border-[#ADFF2F]/40 transition-colors" data-id="element-221">
                <div className="shrink-0 w-10 h-10 rounded-full bg-[#ADFF2F] flex items-center justify-center" data-id="element-222">
                  <Check className="w-6 h-6 text-black" strokeWidth={3} data-id="element-223" />
                </div>
                <div className="flex-1" data-id="element-224">
                  <h3 className="text-xl md:text-2xl text-white font-bold mb-1 font-sans" data-id="element-225">
                    {item.title}
                  </h3>
                  <p className="text-gray-400 text-base md:text-lg leading-relaxed font-sans m-0" data-id="element-226">
                    {item.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
};